import { createReducer } from '@reduxjs/toolkit';
import { MetaType } from 'shared/ts-types/meta-type';
import { adminLogsActions } from 'features/admin-logs/redux/admin-logs.actions';
import {
  AdminLogCategory,
  AdminLogResponse,
} from 'features/admin-logs/api/types';

const initialState = {
  items: [] as AdminLogResponse[],
  meta: {
    itemCount: 0,
    totalItems: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 1,
  } as MetaType,
  loading: false as boolean,
  isLoaded: false as boolean,
  error: {
    adminLogsList: [] as string[],
    categories: [] as string[],
    exportLogs: [] as string[],
  },
  categories: {
    items: [] as AdminLogCategory[],
    loading: false as boolean,
    isLoaded: false as boolean,
  },
  exportLogs: {
    loading: false as boolean,
  },
};

const adminLogs = createReducer(initialState, (builder) => {
  builder.addCase(adminLogsActions.clearState, () => {
    return {
      ...initialState,
    };
  });
  builder.addCase(adminLogsActions.getAdminLogsListRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminLogsActions.getAdminLogsListSuccess, (state, action) => {
    return {
      ...state,
      items:
        action.payload.meta.currentPage === 1
          ? [...action.payload.items]
          : [...state.items, ...action.payload.items],
      meta: action.payload.meta,
      loading: false,
      isLoaded: true,
    };
  });
  builder.addCase(adminLogsActions.getAdminLogsListFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, adminLogsList: action.payload },
    };
  });
  builder.addCase(adminLogsActions.getAdminLogCategoriesRequest, (state) => {
    return {
      ...state,
      categories: {
        ...state.categories,
        loading: true,
      },
    };
  });
  builder.addCase(
    adminLogsActions.getAdminLogCategoriesSuccess,
    (state, action) => {
      const existed = new Map();
      return {
        ...state,
        categories: {
          ...state.categories,
          items: [...state.categories.items, ...action.payload.items].filter(
            (item) => {
              if (!existed.has(item.logCategory)) {
                existed.set(item.logCategory, true);
                return true;
              }
              return false;
            }
          ),
          loading: false,
          isLoaded: true,
        },
      };
    }
  );
  builder.addCase(
    adminLogsActions.getAdminLogCategoriesFailure,
    (state, action) => {
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: false,
          isLoaded: false,
        },
        error: { ...state.error, categories: action.payload },
      };
    }
  );

  builder.addCase(adminLogsActions.exportAdminLogsRequest, (state) => {
    return {
      ...state,
      exportLogs: {
        ...state.exportLogs,
        loading: true,
      },
    };
  });
  builder.addCase(adminLogsActions.exportAdminLogsSuccess, (state) => {
    return {
      ...state,
      exportLogs: {
        ...state.exportLogs,
        loading: false,
      },
    };
  });
  builder.addCase(adminLogsActions.exportAdminLogsFailure, (state, action) => {
    return {
      ...state,
      exportLogs: {
        ...state.exportLogs,
        loading: false,
      },
      error: { ...state.error, exportLogs: action.payload },
    };
  });
});

export default adminLogs;
